<template>
  <div id="app">
    <div class="container">
      <h3 style="text-align: center">个人信息保护及隐私政策</h3>
      <p>更新日期:2024年06月19日</p>
      <p>生效日期:2023年10月17日</p>
      <p>
        为向您提供最佳的服务体验并利于昆明公交的高效运营，在您使用昆明公交（以下统称“我们”）提供的各项服务，可能会以如下方式收集和使用您提供的个人信息，本隐私政策解释这些情况下的信息收集和使用情况。我们非常重视对您个人隐私的保护，在您使用产品及服务前，请您仔细阅读以下内容。若您注册并成为认证用户，视为您同意本隐私政策；若您不同意隐私政策中的任何内容，请立即停止注册、使用或访问昆明公交平台服务。
      </p>
      <p class="title">一、我们如何收集和使用您的个人信息</p>
      <p>我们收集信息，目的是为所有使用我们的用户提供更好的产品和服务。</p>
      <p>
        我们只会收集特定、明确和合法目的所需的信息，不会以与这些目的不符的方式进行进一步处理信息。
      </p>
      <p>我们可能会收集以下类型的信息（可能是个人信也可能不是个人信息）：</p>
      <p>
        1.1当您注册昆明公交帐号时,我们会收集您的昵称、手机号码或邮箱账号,收集这些信息是为了帮助您完成昆明公交的帐号注册,以便我们能够提供服务以及保护您的帐号安全。您的手机号码属于个人敏感信息,收集此类信息是为了能够确认您的身份(如接收验证码)及满足相关法律法规的网络实名制要求。若您不提供这类信息,您可能无法正常使用我们的服务。您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用上述信息。上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会单独征得您的授权同意。
      </p>
      <p>
        1.2在您首次使用服务前，我们会提示您选择是否允许我们获取以及何种情况下可以获取到您的位置信息。获得您的允许后，我们会通过GPS以及能够提供相关信息的其他传感器来获取您的位置信息，目的是为了显示您所在位置周围的可用车辆、运营区或电子围栏规则。
      </p>
      <p>
        1.3当您将要开始使用开锁功能、关锁功能时，我们会在获得您的自主选择同意后，记录您设备上和车辆开关锁的地理位置信息，以便服务器下发开、关锁指令至车辆，向您提供骑行服务。
      </p>
      <p>
        1.4在您骑行过程中，我们会记录您设备上和车辆开关锁的地理位置信息，记录您的出发地、到达地、骑行轨迹、时长及里程信息。我们收集上述信息，是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理用户纠纷的需要。
      </p>
      <p>
        1.5如果您参与推广活动（包括厂商推广活动）时，我们会将您提供的信息用于管理此类活动。若您选择不提供该类信息，则可能无法正常参与相应活动，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。
      </p>
      <p>
        1.6当您骑行车辆时,为保障您的正常服务,我们会收集您的设备信息(与您的设备相关的信息,包括设备SN、设备Mac、设备类型、设备型号名称、系统和性能信息等),车辆信息(与您的车辆相关的信息,包括SN码、中控版本、电池电压、车辆温度、行驶速度等)、日志信息(操作日志、故障日志、服务日志)
        ,位置信息(国家代码、城市代码、地理位置)
        ，这些信息是为了向您提供服务所必须收集的基础信息。
      </p>
      <p>
        1.7当您使用支付功能时，我们仅会向指定的第三方支付软件发起支付请求（例如支付宝、微信），该过程并不收集您的姓名或其他您绑定在第三方支付工具中的信息，也不会将您向我们提供的或在使用骑行服务时产生的信息提供给第三方支付工具。
      </p>
      <p>
        1.8为帮助我们更好地了解骑行服务的运行情况，以便确保运行与提供服务的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据信息。
      </p>
      <p>
        1.9我们收集数据是根据您与我们的互动和您所做出的选择，包括您的隐私设置以及您使用的产品和功能。我们收集的数据可能包括SDK/API/JS代码版本、浏览器、互联网服务提供商、IP地址、平台、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、iOS广告标识符（IDFA)、安卓广告主标识符、网卡（MAC）地址、国际移动设备识别码（IMEI）、设备型号、终端制造厂商、终端设备操作系统版本、会话启动/停止时间、语言所在地、时区和网络状态（WiFi等）、硬盘、CPU和电池使用情况等。
      </p>
      <p>
        1.10为了向您提供【基于位置的相关】功能/服务，我们的产品集成了【高德地图定位】SDK。在向您提供【定位】功能/服务时，【高德地图SDK】需要收集、使用您的【设备信息、位置信息、WLAN及其他传感器信息】，具体请您仔细阅读《高德地图开放平台隐私权政策》【请开发者附访问链接
        <a href="https://lbs.amap.com/home/privacy"
          >https://lbs.amap.com/home/privacy</a
        >】进行了解。
      </p>
      <p>
        1.11个推消息推送SDK：消息推送服务供应商：由每日互动股份有限公司提供推送技术服务，我们可能会将您的设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息提供给每日互动股份有限公司，用于为您提供消息推送技术服务。我们在向您推送消息时，我们可能会授权每日互动股份有限公司进行链路调节，相互促活被关闭的SDK推送进程，保障您可以及时接收到我们向您推送的消息。详细内容请访问《个推用户隐私政策》（需将《个推用户隐私政策》超链至：<a
          href="http://docs.getui.com/privacy"
          >http://docs.getui.com/privacy</a
        >
        ）。
      </p>
      <p>
        1.12友盟统计分析SDK：运营方：友盟同欣（北京）科技有限公司，我们可能会将您的设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息提供给友盟同欣（北京）科技有限公司，用于APP运营统计与分析。详细内容请访问隐私权政策链接：https://www.umeng.com/page/policy
      </p>
      <p>我们开启的权限</p>
      <p>
        为提供相关产品和服务，我们需要您授权开启如下相关权限以收集相关信息。如果您开启这些权限即代表您授权我司可以收集和使用这些信息实现以下功能，如您取消或拒绝开启相关权限，我们将不会继续手机和使用您的这些信息，但可能无法获得这些权限相关的功能或服务。
      </p>
      <p>
        存储权限：我们的系统服务类功能、应用类基本功能以及部分附加功能会在您登陆时调用您的存储权限。
      </p>
      <p>
        位置权限：当您使用我们平台服务中与定位相关的功能时，我们可能需要开启您的设备的位置权限
      </p>
      <p>
        相机或相册权限：当您使用我们平台服务中与拍照、摄像相关的功能时，我们可能需要开启您的设备相机权限与相册权限。
      </p>
      <p>
        蓝牙权限：当您使用我们平台服务中与蓝牙通讯相关的功能时，我们可能需要开启您蓝牙相关权限。
      </p>
      <p>
        NFC权限：当您使用我们平台服务中与NFC相关的功能时，我们可能需要调用您设备NFC相关权限。
      </p>
      <p>
        录音权限：当您使用我们平台服务中的客服咨询功能时，如您选择语音描述您的问题，我们可能需要调用您设备的麦克风相关权限。
      </p>

      <p>拔打电话权限：CALL_PHONE直接拨打电话号码</p>
      <p class="title">二、我们如何使用Cookie技术</p>
      <p>
        为确保网站或APP正常运转，我们会在您的计算机或移动设备上储存名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站或APP能够储存您的偏好数据。我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站或APP时更改用户设置。
      </p>
      <p>三、我们如何共享、转让、公开披露您的个人信息</p>
      <p>
        3.1我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外：
      </p>
      <p>
        3.1.1在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
      </p>
      <p>
        3.1.2我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
      </p>
      <p>
        3.1.3与我们的关联公司共享：您的个人信息可能会与我们关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
      </p>
      <p>
        我们的关联公司包括我们的关联方公司、政府监管平台及公安系统，保险公司以及其他合作伙伴等。
      </p>
      <p>
        3.1.4与授权合作伙伴共享：仅为实现本隐私权政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，我们聘请来提供第三方数据统计和分析服务的公司可能需要采集和访问个人数据以进行数据统计和分析。在这种情况下，这些公司必须遵守我们的数据隐私和安全要求。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。
      </p>
      <p>
        对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
      </p>
      <p>
        3.2我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      </p>
      <p>
        3.2.1在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
      </p>
      <p>
        3.2.2在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
      </p>
      <p>3.3我们仅会在以下情况下，公开披露您的个人信息：</p>
      <p>3.3.1获得您明确同意后；</p>
      <p>
        3.3.2基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
      </p>
      <p>3.4涉及嵌入第三方代码、插件传输个人信息的情形逐项举例:</p>
      <el-table
        :span-method="objectSpanMethod"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          width="50%"
          prop="name"
          align="center"
          label="产品名称"
        />
        <el-table-column
          prop="sdk"
          align="center"
          width="40%"
          label="第三方SDK"
        />
        <el-table-column prop="per" align="center" label="个人信息字段" />
        <el-table-column
          width="50%"
          prop="scene"
          align="center"
          label="应用场景"
        />
        <el-table-column
          width="50%"
          prop="tName"
          align="center"
          label="第三方机构名称"
        />
        <el-table-column
          prop="policy"
          align="center"
          label="第三方相关隐私政策"
        />
      </el-table>
      <p class="title">四、我们如何存储您的信息</p>
      <p>4.1信息存储的地点</p>
      <p>
        我们会按照法律法规规定,将境内收集的用户个人信息存储于中国境内。如果您的个人信息存储地点从中国境内转移到境外的,我们将严格依照法律的规定执行。
      </p>
      <p>4.2信息存储的期限</p>
      <p>一般而言,我们仅在为实现目的所必需的时间内保留您的个人信息,例如:</p>
      <p>
        手机号码:若您需要使用昆明公交服务,我们需要一直保存您的手机号码,以保证您正常使用该服务,当您注销昆明公交帐户后，我们会删除您的相关个人信息。
      </p>
      <p>
        车辆信息：如您要使用昆明公交车辆服务，我们需要一直保存您的车辆和账户绑定信息，以保证您能正常使用该服务，尤其是当您发生误操作时（如删除车辆）我们能恢复您的车辆信息，以保证您正常使用该服务,当您注销昆明公交帐户后，我们会删除您的车辆相关个人信息
      </p>
      <p>
        定位信息:如您需要使用昆明公交基于定位信息的功能时,我们需要一直保存您的车辆的地理位置信息,以保证您正常使用该服务,当您解除绑定后,我们会删除与您相关的地理定位信息。当我们的产品或服务发生停止运营的情形时,我们将以推送通知、公告等形式通知您,并在合理的期限内删除您的个人信息。
      </p>
      <p>
        服务信息：如您使用昆明公交app进行过车联网服务期兑换、充值、转移等功能时，我们需要一直保存您的订单快照信息，以保证数据有误时或售后服务过程中能有一个准确的参考。当我们的产品或服务发生停止运营的情形时,我们将以推送通知、公告等形式通知您,并在合理的期限内删除您的个人信息。
      </p>
      <p class="title">五、我们如何保护您的个人信息</p>
      <p>
        目前,我们不会主动共享或转让您的个人信息至第三方,如在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至第三方情形时,我们会直接征得或确认第三方征得您对上述行为的明示同意。
      </p>
      <p>
        我们不会对外公开披露其收集的个人信息,如必须公开披露时,我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息,并征得您的明示同意。
      </p>
      <p>
        随着我们业务的持续发展,我们有可能进行合并、收购、资产转让等交易,我们将告知您相关情形,按照法律法规及不低于本指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息。
      </p>
      <p>
        另外,根据相关法律法规及国家标准,以下情形中,我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：
      </p>
      <p>1)与我们履行法律法规规定的义务相关的;</p>
      <p>2)与国家安全、国防安全直接相关的;</p>
      <p>3)与公共安全、公共卫生、重大公共利益直接相关的;</p>
      <p>4)与刑事侦查、起诉、审判和判决执行等直接相关的;</p>
      <p>
        5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
      </p>
      <p>6)个人信息主体自行向社会公众公开的个人信息；</p>
      <p>
        7)从合法公开披露的信息中收集个人信息的,如合法的新闻报道、政府信息公开等渠道。
      </p>
      <p class="title">六、您的权力</p>
      <p>
        按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
      </p>
      <p>6.1访问您的个人信息</p>
      <p>
        您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
      </p>
      <p>
        账户信息——如果您希望访问或编辑您的账户中的个人资料信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过访问昆明公交APP执行此类操作。
      </p>
      <p>
        如果您无法通过上述方法访问这些个人信息，您可以随时使用我们的在线或语音客服联系我们。我们将在30天内回复您的访问请求。
      </p>
      <p>6.2更正您的个人信息</p>
      <p>
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“6.1
        访问您的个人信息”中罗列的方式提出更正申请。
      </p>
      <p>
        如果您无法通过上述链接更正这些个人信息，您可以随时使用我们的在线或语音客服联系我们，或发送电子邮件至【<a
          href="lixcx@xinri.com"
          >lixcx@xinri.com</a
        >】。我们将在30天内回复您的更正请求。
      </p>
      <p>6.3删除您的个人信息</p>
      <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
      <p>6.3.1如果我们处理个人信息的行为违反法律法规；</p>
      <p>6.3.2如果我们收集、使用您的个人信息，却未征得您的同意；</p>
      <p>6.3.3如果我们处理个人信息的行为违反了与您的约定；</p>
      <p>6.3.4如果您不再使用我们的产品或服务，或您注销了账号；</p>
      <p>6.3.5如果我们不再为您提供产品或服务。</p>
      <p>
        若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
      </p>
      <p>
        当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
      </p>
      <p>6.4改变您授权同意的范围</p>
      <p>
        每个业务功能需要一些基本的个人信息才能得以完成（见本策略“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。请使用我们的在线或语音客服联系我们，或发送电子邮件至【<a
          href="lixcx@xinri.com"
          >lixcx@xinri.com</a
        >】
      </p>
      <p>
        当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </p>
      <p>6.5个人信息主体注销账户</p>
      <p>
        您随时可注销此前注册的账户，请使用我们的在线或语音客服联系我们，或发送电子邮件至【<a
          href="lixcx@xinri.com"
          >lixcx@xinri.com</a
        >】在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，但根据法律法规的规定或政府部门要求保留的除外。
      </p>
      <p>6.6响应您的上述请求</p>
      <p>
        为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
      </p>
      <p>我们将在十五个工作日内做出答复。</p>
      <p>
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可以拒绝。
      </p>
      <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
      <p>1）与国家安全、国防安全有关的；</p>
      <p>2）与公共安全、公共卫生、重大公共利益有关的；</p>
      <p>3）与犯罪侦查、起诉和审判等有关的；</p>
      <p>4）有充分证据表明您存在主观恶意或滥用权利的；</p>
      <p>5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
      <p>七、未成年人的个人信息保护</p>
      <p>
        我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。
      </p>
      <p>
        对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。如相关父母及监护人不同意按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。
      </p>
      <p>
        尽管当地法律和习俗对儿童的定义不同，但我们将不满 14
        周岁的任何人均视为儿童。
      </p>
      <p>
        如果我们证实自己在未事先获得可证实的父母或监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
      </p>
      <p>八、通知和修订</p>
      <p>
        为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在我们移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。
      </p>
      <p>九、如何联系我们</p>
      <p>
        如果您对本隐私政策有任何疑问、意见或建议，可通过APP内意见反馈与我们联系，也可以通过以下方式与我们联系：
      </p>
      <p>公司名称：无锡锂享出行科技有限公司</p>
      <p>个人信息保护电子邮箱：<a href="lixcx@xinri.com">lixcx@xinri.com</a></p>
      <p>个人信息保护电话：400-888-6999</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: "昆明公交app",
          sdk: "友盟统计分析SDK",
          per:
            "设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息",
          scene: "进行APP运营统计与分析",
          tName: "友盟同欣（北京）科技有限公司",
          policy: "https://www.umeng.com/page/policy",
        },
        {
          name: "昆明公交app",
          sdk: "高德地图",
          per: "设备信息、位置信息",
          scene: "提供地图及定位相关服务",
          tName: "高德软件有限公司 https://lbs.amap.com",
          policy: "https://lbs.amap.com/home/privacy/",
        },
        {
          name: "昆明公交app",
          sdk: "个推消息推送",
          per:
            "设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息",
          scene: "消息推送服务",
          tName: "每日互动股份有限公司",
          policy: "http://docs.getui.com/privacy",
        },
        {
          name: "昆明公交app",
          sdk: "微信支付",
          per: "设备信息",
          scene: "电商支付",
          tName: "腾讯科技(深圳)有限公司 https://open.weixin.qq.com",
          policy:
            "https://support.weixin.qq.com/cgi-bin/mmsupport-bin/readtemplate?stype=&promote=&fr=〈=zh_cn&adtag=&check=false&nav=faq&t=weixin_agreement",
        },
        {
          name: "昆明公交app",
          sdk: "支付宝支付",
          per: "设备信息",
          scene: "电商支付",
          tName: "蚂蚁金服(杭州)网络技术有限公司 https://open.alipay.com/",
          policy: "https://render.alipay.com/p/c/k2cx0tg8",
        },
        {
          name: "昆明公交app",
          sdk: "Udesk在线客服",
          per: "设备信息",
          scene: "智能客服服务",
          tName: "沃丰科技",
          policy: "https://www.udesk.cn/terms_service.html",
        },
        {
          name: "昆明公交app",
          sdk: "AdBright",
          per: "设备信息、网络信息、定位信息",
          scene: "广告服务",
          tName: "皓量科技（深圳）有限公司",
          policy: "https://www.adbright.cn/private.html",
        },
        {
          name: "昆明公交app",
          sdk: "广点通 SDK",
          per:
            "个人常用设备信息（IMEI、序列号、IMSI、AndroidID）、位置信息、网络信息、获取陀螺仪传感器,加速度传感器",
          scene: "第三方广告投放",
          tName: "腾讯科技（北京）有限公司",
          policy: "https://e.qq.com/optout.html",
        },
        {
          name: "昆明公交app",
          sdk: "穿山甲 SDK",
          per:
            "设备标识符（Android如：Android ID、IMEI、IMSI、OAID、ICCID、GAID、MEID、MAC地址、设备序列号、build_serial、BSSID、SSID）、设备信息（如：设备厂商、设备型号、操作系统版本)、网络信息（如：运营商信息、IP地址、网络信号强度、传感器信息）、应用信息（如：开发者应用名、应用包名、应用版本号、应用前后台状态）、已安装APP信息、运行中进程信息、位置信息、获取陀螺仪传感器,加速度传感器",
          scene: "广告投放合作,向用户推送广告信息、广告归因、反作弊",
          tName: "北京巨量引擎网络技术有限公司",
          policy: "https://www.pangle.cn/help/doc/5fc4f25f7b550100157c01d0",
        },
        {
          name: "昆明公交app",
          sdk: "腾讯 bugly SDK",
          per: "日志信息、设备 ID、联网信息、系统名称、系统版本以及国家码",
          scene: "实现热修复",
          tName: "腾讯科技（北京）有限公司",
          policy: "https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf",
        },
      ],
    };
  },
  methods: {
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 7 === 0) {
          return {
            rowspan: 7,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>

<style>
.title {
  font-weight: bold;
}
.el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: black !important;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: black !important;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  color: black !important;
}
</style>
